import fetchClient from '../components/common/FetchClient';

const receiveNoSalesGoalsType = 'NO_SALES_GOALS';

const requestSalesGoalsType = 'REQUEST_SALES_GOALS';
const receiveSalesGoalsType = 'RECEIVE_SALES_GOALS';
const setSalesMaxValue = 'SET_SALES_MAXVALUE';

const initialState = {
    isLoading: false,
    noSalesGoalsFound: true,
    noSalesGoalsText: 'Checking sales goals...',
    salesActual: 1000,
    salesGoalMaxValue: 2000,
    salesTracking: 0,
    salesGoal: 0,
    gpGoal: 30,
    gpActual: 500,
    nbActual: 500,
    nbTracking: 0,
    nbGoalMaxValue: 2000,
    nbGoal: 0
};

export const actionCreators = {
    
    queryGoals: data => async (dispatch, getState) => {
        dispatch({ type: requestSalesGoalsType });

        const url = `/api/SalesGoals/QuerySalesGoals`;

        fetchClient(url, {
            params: {
                azureToken: ''
            }
        }).then(function (resp) {
            console.log(resp);
            if (resp) {
                if (resp.data.SalesGoalResp.ResponseCode["#text"] === "9031" || resp.data.SalesGoalResp.ResponseCode["#text"] === "-6011") {
                    var msg = resp.data.SalesGoalResp.ResponseCode.Msg;

                    dispatch({ type: receiveNoSalesGoalsType, msg });
                    return;
                }

                var goalData = resp.data.SalesGoalResp.SalesGoal;

                var workingDays = Number(goalData.WorkingDays);
                var workingDaysMTD = Number(goalData.WorkingDaysMTD);
                var salesActual = Number(goalData.ActualSales);
                var actualGp = Number(goalData.ActualGp);
                var nbActual = Number(goalData.NewBusinessActual);
                var nbGoal = Number(goalData.NewBusinessGoal);
                var salesGoal = Number(goalData.SalesGoal);

                var nbTracking = 0;
                var salesTracking = 0;
                var salesGoalMaxValue = 0;
                var nbGoalMaxValue = 0;
                var trackingDays = 0;

                if (workingDays > 0)
                {
                    trackingDays = workingDaysMTD / workingDays;
                }

                if (workingDaysMTD > 0) {
                    salesTracking = salesActual / workingDaysMTD * workingDays;
                }

                if ((salesTracking * .1 + salesTracking) > (salesGoal * .25 + salesGoal)) {
                    salesGoalMaxValue = salesTracking * .1 + salesTracking;
                }
                else {
                    salesGoalMaxValue = salesGoal * .25 + salesGoal;
                }

                actualGp = (actualGp / salesActual) * 100;

                if (workingDaysMTD > 0) {
                    nbTracking = nbActual / workingDaysMTD * workingDays;
                }

                if ((nbTracking * .1 + nbTracking) > (nbGoal * .25 + nbGoal)) {
                    nbGoalMaxValue = nbTracking * .1 + nbTracking;
                }
                else {
                    nbGoalMaxValue = nbGoal * .25 + nbGoal;
                }

                dispatch({
                    type: setSalesMaxValue,
                    salesGoalMaxValue,
                    salesTracking,
                    salesActual,
                    salesGoal,
                    actualGp,
                    nbTracking,
                    nbGoalMaxValue,
                    nbActual,
                    nbGoal
                });
            }
        });

        dispatch({ type: receiveSalesGoalsType });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestSalesGoalsType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveSalesGoalsType) {
        return {
            ...state,
            isLoading: false
        };
    }

    if (action.type === receiveNoSalesGoalsType) {
        return {
            ...state,
            isLoading: false,
            noSalesGoalsFound: true,
            noSalesGoalsText: action.msg
        }
    }

    if (action.type === setSalesMaxValue) {
        console.log(action);
        return {
            ...state,
            noSalesGoalsFound: false,
            salesGoalMaxValue: action.salesGoalMaxValue,
            salesTracking: action.salesTracking,
            salesActual: action.salesActual,
            salesGoal: action.salesGoal,
            gpActual: action.actualGp,
            nbTracking: action.nbTracking,
            nbGoalMaxValue: action.nbGoalMaxValue,
            nbActual: action.nbActual,
            nbGoal: action.nbGoal
        }
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/SalesGoals.js